import { ConnectedIntegrationList } from '@modules/integrationsV2/components/IntegrationsContainer/IntegrationsSourceDetailView/IntegrationSourceConnectedIntegrations';
import { ConnectedIntegrationChannelList } from '@modules/integrationsV2/components/IntegrationsContainer/IntegrationsSourceDetailView/IntegrationSourceConnectedIntegrations/ConnectedIntegrationChannelList';
import { useIsIntegrationContextEnabled } from '@modules/integrationsV2/hooks';
import { IntegrationSource } from '@modules/integrationsV2/types';
import { getIsIntegrationChannelsMetadataSupported } from '@modules/integrationsV2/utils';
import { IntegrationViewFragment } from 'generated/graphql';

interface IntegrationSourceConnectedIntegrationsProps {
  integrations: IntegrationViewFragment[];
  integrationSource: IntegrationSource;
}

export const IntegrationSourceConnectedIntegrations = ({
  integrationSource,
  integrations,
}: IntegrationSourceConnectedIntegrationsProps) => {
  const isIntegrationContextEnabled = useIsIntegrationContextEnabled();

  const isIntegrationChannelsMetadataSupported =
    getIsIntegrationChannelsMetadataSupported(integrationSource.channel.type);

  if (isIntegrationContextEnabled && isIntegrationChannelsMetadataSupported) {
    return (
      <ConnectedIntegrationChannelList
        integrations={integrations}
        integrationSource={integrationSource}
      />
    );
  }

  return (
    <ConnectedIntegrationList
      integrationSource={integrationSource}
      integrations={integrations}
    />
  );
};
